/* @ngInject */
const format = (
  utils,
  valueHandler
) => {
  const self = {}

  self.user = (_contact) => {
    const contact = utils.copy(_contact)

    contact.comment = utils.removeHtmlLineBreak(contact.comment)

    return contact
  }

  self.server = (_contact) => {
    const contact = utils.copy(_contact)

    for (let i = 0; i < contact.phones.length; i++) {
      if (valueHandler.isId(contact.phones[i].contactId)) {
        contact.phones.splice(i, 1)
      }
    }

    for (let i = 0; i < contact.emails.length; i++) {
      if (valueHandler.isId(contact.emails[i].contactId)) {
        contact.emails.splice(i, 1)
      }
    }

    return contact
  }

  return self
}

export default format



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/services/format.service.js